import styles from './WatchFaceUniversalLink.module.scss';
import { Helmet, HelmetProvider } from 'react-helmet-async';

export function WatchFaceUniversalLinkPage() {
  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet='utf-8' />
        <meta name='description' content='Exclusive watch faces for Apple Watch!' />
        <meta property='og:title' content='Tap to install' />
        <meta property='og:description' content='Exclusive watch faces for Apple Watch!' />
        <meta property="og:image" content="https://watchfaces.club/facebook-cover.jpg" />
        <title>Watch Faces Club</title>
      </Helmet>

      <div className={styles.container}>
        <div className={styles.logoContainer}>
          <img
            className={styles.appLogo}
            src='/assets/app_logo.svg'
            alt='Watch Faces Club'
          />
        </div>
        <div className={styles.buttonContainer}>
          <a
            className={styles.downloadButton}
            href='https://apps.apple.com/us/app/watch-faces-widgets-gallery/id6498901400'
          >
            <img
              src='/assets/download_button.svg'
              alt='Download on the App Store'
            />
          </a>
        </div>
      </div>
    </HelmetProvider>
  );
}
